import React from 'react';
import {promiseWait, useOnceCall} from 'data/utils/shortcuts';
import {IUser} from 'data/redux/reducers/authenticationReducer';
import {config} from 'data/utils/constants';
import {Helmet} from "react-helmet";

interface ICrispChatProps {
  userDetails?: IUser;
  hideOnMobile?: boolean;
  loading?: boolean;
}

const pushToCrisp = (key, value) => {
  if (key && value && (window as any).$crisp) {
    if (!(window as any).$pushedToCrisp) {
      (window as any).$pushedToCrisp = [];
    }
    const k = `${key}-${value}`;
    try {
      if (!(window as any).$pushedToCrisp.includes(k)) {
        (window as any).$pushedToCrisp.push(k);
        (window as any).$crisp.push(["set", key, [value]]);
      }
    } catch (e) {
      console.log(key, value, e)
    }
  }
};


const initCrispChat = () => {
  if (!(window as any).$crisp) {
    (window as any).$crisp = [];
    (window as any).CRISP_WEBSITE_ID = config.crisp.websiteId;
    const script: any = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.defer = 1;
    document.getElementsByTagName("head")[0].appendChild(script);
  }
};


const waitUntilCrispInit = () => new Promise(resolve => {
  if ((window as any).$crisp)
    resolve(true);
  else {
    promiseWait(1000)
      .then(() => waitUntilCrispInit())
      .then(resolve);
  }
});
/*
const waitUntilCrispInit = () => promiseWaitCondition(1000, (count) => Promise.resolve(!!(window as any).$crisp));
*/
export const openCrispChat = async () => {
  initCrispChat();
  await waitUntilCrispInit();
  if ((window as any).$crisp) {
    (window as any).$crisp.push(['do', 'chat:open'])
  }
};


const CrispChat = (props: ICrispChatProps) => {
  useOnceCall(initCrispChat, props.loading === false);
  useOnceCall(() => {
    pushToCrisp("user:email", props.userDetails.email);
    pushToCrisp("user:phone", props.userDetails.phone);
    pushToCrisp("user:nickname", [props.userDetails.firstName, props.userDetails.lastName].join(" "));
  }, props.loading === false && (window as any).$crisp && typeof (window as any).$crisp === 'object' && props.userDetails && typeof props.userDetails === 'object');
  if (props.hideOnMobile) {
    return (<Helmet>
      <style>{`
        @media (max-width: 767px) {
        #crisp-chatbox .cc-unoo {
        display: none !important;
      }
      }
        `}
      </style>
    </Helmet>)
  }

  return (null);
};
CrispChat.defaultProps = {
  userDetails: {},
  hideOnMobile: false,
  loading: false,
};
export default React.memo(CrispChat);
